import {Collection} from 'vue-mc'
import {OutstandingInvoicesModel} from '@/models/outstandingInvoiceModel'

/**
 * outstandingInvoicesCollection collection
 */

export default class outstandingInvoicesCollection extends Collection {

	// Default attributes that define the "empty" state.
	defaults() {
		return {

		}
	}

	model() {
		return OutstandingInvoiceModel;
	}

	// Route configuration
	routes() {
		return {
			fetch: "clients/invoices/outstanding",
            post: "clients/invoices/downloadInvoice",
		}
	}
}



// WEBPACK FOOTER //
// ./src/collections/outstandingInvoicesCollection.js